<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import Adjust from '@adjustcom/adjust-web-sdk';

export default {
  name: "add",
  data() {
    return {};
  },
  mounted() {
    window.addEventListener(
      "hashchange",
      () => {
        var currentPath = window.location.hash.slice(1); // 获取输入的路由
        if (this.$router.path !== currentPath) {
          this.$router.push(currentPath); // 动态跳转
        }
      },
      false
    );
  },
  created() {
    this.initAD()
  },
  methods: {
    initAD(){
      try {
        let _this = this
        Adjust.initSdk({
          appToken: "mha8vtl6ndvk",
          environment: _this.isProd() ? "production":"sandbox",
          logLevel: _this.isProd() ? "none":"verbose",
          attributionCallback: (e, attribution)=>{
            localStorage.setItem("adjust_id", attribution.adid);
            if(_this.isProd()){
              return
            }
            console.log("attributionCallback_Adid: " + attribution.adid);
            console.log("attributionCallback_Tracker Token: " + attribution.tracker_token);
            console.log("attributionCallback_Tracker Name: " + attribution.tracker_name);
            console.log("attributionCallback_Network: " + attribution.network);
            console.log("attributionCallback_Campaign: " + attribution.campaign);
            console.log("attributionCallback_Adgroup: " + attribution.adgroup);
            console.log("attributionCallback_Creative: " + attribution.creative);
            console.log("attributionCallback_Click Label: " + attribution.click_label);
            console.log("attributionCallback_Attribution State: " + attribution.state);
          },
        })
      } catch (error) {
        if(_this.isProd()){
          return
        }
        console.log("attributionCallback_error: " + error);
      }
    },
    isProd(){
      return window.location.host == "www.mastersol.tech"
    }
  },
  metaInfo: {
    title: "MasterSol", // set a title
    meta: [
      {
        // set meta keyWords
        name: "keyWords",
        content:
          "cash,dinero,perú,depósito,urgente,crédito,credit,rápido,préstamo,efectivo",
      },
      {
        // set meta description
        name: "description",
        content:
          "MasterSol es una plataforma para préstamo seguro、préstamo en efectivo y préstamo de crédito personal sin hipoteca",
      },
    ],

    link: [
      {
        // set link
        rel: "asstes",
        href: "https://www.mastersol.tech/home",
      },
    ],
  },
};
</script>

<style lang="scss">
html {
  font-size: 40px;
}
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
}
p,
ul {
  margin: 0;
}
a {
  text-decoration: none;
  cursor: pointer;
}
</style>
